import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Container,
  Radio,
  RadioGroup,
  FormLabel,
} from "@mui/material";

import FormControlLabel from "@mui/material/FormControlLabel";
import dateFormat from "dateformat";
import UserHeader from "../../components/Headers/UserHeader.js";

const Profilegroup = () => {
  const [selectedValue, setSelectedValue] = React.useState({
    admin: true,
    remedy: true,
    ops: true,
    read: true,
    all: true,
  });

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const [userlist, setusers] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/user_management/user_list/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          localStorage.setItem("user_access", data.detail);
          window.location.href = "/access_denied";
        } else {
          setusers(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [adminuserlist, setadminuserlist] = useState([]);
  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/adminuserlistView/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setadminuserlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [remedyuserlist, setremedyuserlist] = useState([]);
  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/remedyuserlistView/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setremedyuserlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [opsuserlist, setopsuserlist] = useState([]);
  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/opsuserlistView/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setopsuserlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [readonlyuserlist, setreadonlyuserlist] = useState([]);
  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/readonlyuserlistView/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setreadonlyuserlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  return (
    <>
      <UserHeader content="This is your group page, here you can see the all groups and user mapping." />
      <Card className="shadow">
        <FormLabel>
          <h3 className="mb-0 py-3">Group information</h3>
        </FormLabel>
        <RadioGroup
          row
          aria-label="group information"
          name="row-radio-buttons-group"
          className="px-10"
        >
          <FormControlLabel
            checked={selectedValue === "admin"}
            onChange={handleChange}
            name="radio-button-demo"
            value="admin"
            control={<Radio />}
            label="Admin"
          />
          <FormControlLabel
            checked={selectedValue === "remedy"}
            onChange={handleChange}
            name="radio-button-demo"
            value="remedy"
            control={<Radio />}
            label="Remedy"
          />
          <FormControlLabel
            checked={selectedValue === "ops"}
            onChange={handleChange}
            name="radio-button-demo"
            value="ops"
            control={<Radio />}
            label="OPS"
          />
          <FormControlLabel
            checked={selectedValue === "read"}
            onChange={handleChange}
            name="radio-button-demo"
            value="read"
            control={<Radio />}
            label="Read Only"
          />
        </RadioGroup>
      </Card>
      <br />
      {selectedValue.all === true ? (
        <Card className="shadow">
          <CardHeader className="bg-white border-0">
            <h3 className="mb-0">Admin Group</h3>
          </CardHeader>
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Email-ID</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created at</TableCell>
                  </TableRow>
                </TableHead>
                {userlist.map((userlist) => {
                  return (
                    <TableBody>
                      {userlist.is_active === "True" ? (
                        <TableRow>
                          <TableCell>{userlist.username}</TableCell>
                          <TableCell>{userlist.email}</TableCell>
                          <TableCell>Active</TableCell>
                          <TableCell>
                            {dateFormat(
                              userlist.created_at,
                              "mmmm dS, yyyy h:MM TT "
                            )}
                            (IST)
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          </Paper>
        </Card>
      ) : (
        ""
      )}
      {selectedValue === "admin" ? (
        <Card className="shadow">
          <CardHeader className="bg-white border-0">
            <h3 className="mb-0">Admin Group</h3>
          </CardHeader>
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Email-ID</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created at</TableCell>
                  </TableRow>
                </TableHead>
                {adminuserlist.map((adminuserlist) => {
                  return (
                    <TableBody>
                      {adminuserlist.is_active === "True" ? (
                        <TableRow>
                          <TableCell>{adminuserlist.username}</TableCell>
                          <TableCell>{adminuserlist.email}</TableCell>
                          <TableCell>Active</TableCell>
                          <TableCell>
                            {dateFormat(
                              adminuserlist.created_at,
                              "mmmm dS, yyyy h:MM TT "
                            )}
                            (IST)
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          </Paper>
        </Card>
      ) : (
        ""
      )}
      {selectedValue === "remedy" ? (
        <Card className="shadow">
          <CardHeader className="bg-white border-0">
            <h3 className="mb-0">Remedy Group</h3>
          </CardHeader>
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Email-ID</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created at</TableCell>
                  </TableRow>
                </TableHead>
                {remedyuserlist.map((remedyuserlist) => {
                  return (
                    <TableBody>
                      {" "}
                      {remedyuserlist.is_active === "True" ? (
                        <TableRow>
                          <TableCell>{remedyuserlist.username}</TableCell>
                          <TableCell>{remedyuserlist.email}</TableCell>
                          <TableCell>Active</TableCell>
                          <TableCell>
                            {dateFormat(
                              remedyuserlist.created_at,
                              "mmmm dS, yyyy h:MM TT "
                            )}
                            (IST)
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          </Paper>
        </Card>
      ) : (
        ""
      )}
      {selectedValue === "ops" ? (
        <Card className="shadow">
          <CardHeader className="bg-white border-0">
            <h3 className="mb-0">OPS Group</h3>
          </CardHeader>
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Email-ID</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created at</TableCell>
                  </TableRow>
                </TableHead>
                {opsuserlist.map((opsuserlist) => {
                  return (
                    <TableBody>
                      {" "}
                      {opsuserlist.is_active === "True" ? (
                        <TableRow>
                          <TableCell>{opsuserlist.username}</TableCell>
                          <TableCell>{opsuserlist.email}</TableCell>
                          <TableCell>Active</TableCell>
                          <TableCell>
                            {dateFormat(
                              opsuserlist.created_at,
                              "mmmm dS, yyyy h:MM TT "
                            )}
                            (IST)
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          </Paper>
        </Card>
      ) : (
        ""
      )}
      {selectedValue === "read" ? (
        <Card className="shadow">
          <CardHeader className="bg-white border-0">
            <h3 className="mb-0">Read-Only Group</h3>
          </CardHeader>
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Email-ID</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created at</TableCell>
                  </TableRow>
                </TableHead>
                {readonlyuserlist.map((readonlyuserlist) => {
                  return (
                    <TableBody>
                      {" "}
                      {readonlyuserlist.is_active === "True" ? (
                        <TableRow>
                          <TableCell>{readonlyuserlist.username}</TableCell>
                          <TableCell>{readonlyuserlist.email}</TableCell>
                          <TableCell>Active</TableCell>
                          <TableCell>
                            {dateFormat(
                              readonlyuserlist.created_at,
                              "mmmm dS, yyyy h:MM TT "
                            )}
                            (IST)
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          </Paper>
        </Card>
      ) : (
        ""
      )}
    </>
  );
};

export default Profilegroup;